import { useState } from "react";
import { useLocation } from "react-router-dom";
import useRequest from "../../../utils/useRequest";

import PageWrapper from "../../../components/PageWrapper";
import ItemInvoiceHeader from "./ItemInvoiceHeader";
import ItemInvoiceBody from "./ItemInvoiceBody";
import ItemInvoiceFooter from "./ItemInvoiceFooter";

export default function PreviewItemInvoice() {
  const location = useLocation();
  const dataFromNavigation = location.state?.data;
  const [data, setData] = useState(dataFromNavigation);

  return (
    <PageWrapper>
      <ItemInvoiceHeader invoiceHeader={data?.documentPath} />
      <ItemInvoiceBody data={data} setData={setData} mode="preview" />
      <ItemInvoiceFooter />
    </PageWrapper>
  );
}
